import { render, staticRenderFns } from "./teacherprofile.vue?vue&type=template&id=251f6c7e&scoped=true"
import script from "./teacherprofile.vue?vue&type=script&lang=js"
export * from "./teacherprofile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251f6c7e",
  null
  
)

export default component.exports